/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema for updating clinic trace metadata on a conversation.
 */
export interface UpdateConversationTraceMetadataRequest {
  /** Nori user ID of the conversation's patient */
  user_id: string;
  /** The exported Braintrust child span ID for the clinic side of the conversation. */
  clinic_braintrust_span_id: string;
}
